import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withTranslation } from 'react-i18next';
import i18n from 'cityads-v3/i18n';

import MUITextField from '@material-ui/core/TextField';

import classes from './TextField.scss';

@withTranslation(['main'], { i18n, wait: !!window })
export default class TextField extends Component {

  static propTypes = {
    maxLength: PropTypes.number,
    minLength: PropTypes.number,
    renderMinMaxLength: PropTypes.bool,
    isLoading: PropTypes.bool,
  };

  static defaultProps = {
    maxLength: 0,
    minLength: 0,
    isLoading: false,
    renderMinMaxLength: true
  };

  onChangeOnlyDigits = evt => {
    this.props.onChange({
      ...evt,
      target: {
        ...evt.target,
        value: evt.target.value.replace(/[^\d.]/g, '')
      }
    })
  }

  render() {
    const {
      i18n,
      i18nLoadedAt,
      InputLabelProps,
      InputProps,
      inputProps,
      SelectProps,
      maxLength,
      minLength,
      renderMinMaxLength,
      helperText,
      onlyDigits,
      onChange,
      isLoading,
      t,
      tReady,
      ...others
    } = this.props;
    const { value, placeholder } = others;

    return (
      <MUITextField
        {...others}

        onChange={onlyDigits ? this.onChangeOnlyDigits : onChange}

        InputLabelProps = {{
          ...InputLabelProps,
          classes: {
            ...InputLabelProps?.classes,
            root: classNames(classes.InputLabel, InputLabelProps?.classes?.root),
          },
          shrink: InputLabelProps?.shrink ?? (placeholder ? undefined : !!(value && (value.length || value.value)) || typeof value === 'number'),
        }}
        InputProps = {{
          ...InputProps,
          className: classes.root,
        }}
        inputProps = {{
          ...inputProps,
          maxLength: maxLength || undefined
        }}
        SelectProps = {{
          ...SelectProps,
          classes: {
            icon: isLoading ? classes.selectIconLoading : undefined
          }
        }}
        helperText={(helperText || maxLength || minLength) ?
          (
            <span className={classes.helper}>
              {helperText ?
                (
                  <span className={classes.helperText}>
                    {helperText}
                  </span>
                )
                :
                null
              }
              {(renderMinMaxLength && (maxLength || minLength)) ?
                (
                  <span className={classes.minMax}>
                    {maxLength ? <span className={classes.maxlength}>{value?.length ?? 0}/{maxLength}</span> : undefined}
                    {minLength ? <span className={classes.maxlength}>{value?.length ?? 0} ({t('min')} {minLength})</span> : undefined}
                  </span>
                )
                :
                null
              }
            </span>
          )
          :
          null
        }
      />
    );
  }

}
